export const getGuid = () => {
  const generateHex = () => {
    const array = new Uint16Array(1);
    crypto.getRandomValues(array);
    return array[0].toString(16).padStart(4, "0");
  };

  return `${generateHex()}${generateHex()}-${generateHex()}-4${generateHex().substr(
    0,
    3
  )}-${generateHex()}-${generateHex()}${generateHex()}${generateHex()}`.toLowerCase();
};
